
//系统路由
const routes = [
	{
		name: "layout",
		path: "/",
		meta: { title: "首页" },
		component: () => import("@/components/HelloWorld.vue"),
	},
	{
		path: "/login",
		component: () => import("@/views/Login.vue"),
		meta: {
			title: "登录",
		},
	},
	{
		path: '/404',
		name: '404',
		component: () => import('../views/404.vue')
	},
	{
		path: '/agreement2',
		name: 'agreement2',
		component: () => import('../components/mian/agreement/agreement2.vue')
	},
	{
		path: '/agreement1',
		name: 'agreement1',
		component: () => import('../components/mian/agreement/agreement1.vue')
	},
];

export default routes;
